<template>
	<div>
		<div class="main flex-shrink flex-wrap flex-col">
			<form>
				<div v-if="!isLoading" class="flex flex-shrink flex-col justify-start">
					<div class=" w-full pr-0 md:pr-4">
						<BaseSelect
							required="true"
							:label="$t('employees')"
							:options="employees"
							v-model="selectedEmployee"
							ref="BaseSelect-Title"
							:allow-empty="true"
							style="min-width: 350px"
							class="w-full"
						/>
						<BaseDatepicker
							v-model="dateRange"
							mode="range"
							required="true"
							ref="DatePicker"
							:label="$t('period')"
							:columns="3"
							:rows="1"
							:min_date="new Date()"
							:placeholder="$t('period')"
						/>
					</div>
				</div>
				<LoadingSpinner v-else />
			</form>
		</div>
	</div>
</template>

<script>
import { RepairshopsApiFactory, UserApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import BaseDatepicker from '@/components/forms/inputs/BaseDatepicker.vue';
import Validate from '@/mixins/Validate';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'AddVacationModal',
	components: { BaseSelect, BaseDatepicker, LoadingSpinner },
	mixins: [Validate, Authentication],
	data() {
		return {
			isLoading: true,
			dateRange: [],
			vacationID: null,
			employees: [],
			selectedEmployee: null,
		};
	},
	methods: {
		getEmployees() {
			UserApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.userGet()
				.then(response => {
					response.data.map(option => {
						option.value = option.person.id;
						option.display = option.person.firstName + ' ' + option.person.lastName;
						this.employees.push(option);
						if (this.getUser.person.id === option.person.id && this.vacationID === null) {
							this.selectedEmployee = option;
						}
					});
				})
				.finally(this.getVacation);
		},
		save() {
			if (this.validate()) {
				const startDate = new Date(this.dateRange.start);
				startDate.setHours(4, 0, 0);
				const endDate = new Date(this.dateRange.end);
				endDate.setHours(4, 0, 0);

				const vacation = { start: startDate, end: endDate, person_id: this.selectedEmployee.person.id };

				if (this.vacationID != null) {
					RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
						.repairshopVacationsIdPut(this.vacationID, vacation)
						.then(response => {
							this.$store.commit('setConfirmLeaving', false);
							this.$swal(this.$t('general.success').toString(), this.$t('absence_updated').toString(), 'success').then(() => {
								this.$root.$emit('updateVacations');
								this.$router.go(-1);
							});
						})
						.catch(error => {
							console.log(error);
							this.$swal(this.$t('general.error').toString(), this.$t('absence_saving_error').toString(), 'error');
						});
				} else {
					RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
						.repairshopVacationsPost(vacation)
						.then(response => {
							this.$store.commit('setConfirmLeaving', false);
							this.$swal(this.$t('general.success').toString(), this.$t('absence_saved').toString(), 'success').then(() => {
								this.$root.$emit('updateVacations');
								this.$router.go(-1);
							});
						})
						.catch(error => {
							console.log(error);
							this.$swal(this.$t('general.error').toString(), this.$t('absence_saving_error').toString(), 'error');
						});
				}
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
		getVacation() {
			if (this.$route.params.id != null) {
				this.isLoading = true;
				this.vacationID = this.$route.params.id;
				RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.repairshopVacationsIdGet(this.vacationID)
					.then(response => {
						this.dateRange = { start: new Date(response.data.data.start), end: new Date(response.data.data.end) };
						this.employees.forEach((employee, index) => {
							if (employee.person.id === response.data.data.person.id) {
								this.selectedEmployee = this.employees[index];
							}
						});
						this.isLoading = false;
					});
			} else {
				this.isLoading = false;
			}
		},
	},
	mounted() {
		this.isLoading = true;
		if (!this.isUserAllowedInLevel5or6) {
			this.$emit('authNotAllowed');
		} else {
			this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
			this.getEmployees();
		}
	},
};
</script>

<style scoped></style>
